"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftProposalStatus = void 0;
exports.instanceOfShiftProposalStatus = instanceOfShiftProposalStatus;
exports.ShiftProposalStatusFromJSON = ShiftProposalStatusFromJSON;
exports.ShiftProposalStatusFromJSONTyped = ShiftProposalStatusFromJSONTyped;
exports.ShiftProposalStatusToJSON = ShiftProposalStatusToJSON;
exports.ShiftProposalStatusToJSONTyped = ShiftProposalStatusToJSONTyped;
/**
 *
 * @export
 */
exports.ShiftProposalStatus = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    Expired: 'EXPIRED',
    Canceled: 'CANCELED'
};
function instanceOfShiftProposalStatus(value) {
    for (const key in exports.ShiftProposalStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.ShiftProposalStatus, key)) {
            if (exports.ShiftProposalStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ShiftProposalStatusFromJSON(json) {
    return ShiftProposalStatusFromJSONTyped(json, false);
}
function ShiftProposalStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShiftProposalStatusToJSON(value) {
    return value;
}
function ShiftProposalStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=ShiftProposalStatus.js.map